import { colours } from "@shared/ui.design-system";
import { ChevronDownIcon } from "@shared/ui.icons";
import { Typography } from "@shared/ui.primitives";

import * as styles from "./FindOutMore.css";
export interface FindOutMoreProps {
  id: string;
}
export const FindOutMore = ({ id }: FindOutMoreProps) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <a
      href={`#${id}`}
      className={styles.findOutMoreWrapper}
      onClick={handleClick}
    >
      <Typography as="span" variant="button-sm" colour="primary-medium">
        Find Out More
      </Typography>
      <ChevronDownIcon
        width={25}
        height={20}
        className={styles.bobbingChevron}
        fill={colours.primary.medium}
      />
    </a>
  );
};
